import { REGEX_CONSTANT } from "../../../../constant/regexConstant";

export const validDriver = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "first_name":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data.length > 50 || data.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 50", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "last_name":
      if (data.length > 50 ) {
        error[namespace] = translate("Field cannot be less than 1 and more than 50", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "nik":
      if (data.length > 20) {
        error[namespace] = translate("Field cannot be less than 1 and more than 20", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data && !REGEX_CONSTANT.NIK.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    // case "phone":
    //   if (!data) {
    //     error[namespace] = translate("COMMON:REQUIRE", {
    //       field: translate("CUSTOMER:ADDITIONAL_NAME"),
    //     });
    //   } else if (!REGEX_CONSTANT.PHONE_NUMBER.test(data)) {
    //     error[namespace] = translate("Invalid Format", {
    //       field: translate("Role ID"),
    //     });
    //   }else if (data.length > 35) {
    //     error[namespace] = translate("Max character is 35 ", {
    //       field: translate("CUSTOMER:ADDITIONAL_NAME"),
    //     });
    //   } else {
    //     error[namespace] = null;
    //   }
    //   break;
      case "phone":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          });
        } else if (!REGEX_CONSTANT.PHONE_NUMBER.test(data)) {
          error[namespace] = translate("Invalid Format", {
            field: translate("Role ID"),
          });
        } else if (data.length > 12 || data.length < 10) {
          error[namespace] = translate("Field cannot be less than 10 and more than 12", {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          });
        } else {
          error[namespace] = null;
        }
        break;
    case "email":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.EMAIL.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;

    case "country_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
      // case "island_id":
      // if (!data) {
      //   error[namespace] = translate("COMMON:REQUIRE", {
      //     field: translate("CUSTOMER:ADDITIONAL_NAME"),
      //   });
      // } else {
      //   error[namespace] = null;
      // }
      // break;
    case "district_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "sub_district_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "urban_village_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "address":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data.length > 100 || data.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "neighbourhood":
      // if (!data) {
      //   error[namespace] = translate("COMMON:REQUIRE", {
      //     field: translate("CUSTOMER:ADDITIONAL_NAME"),
      //   });
      // } else 
      if (data &&(data.length > 3 || data.length <3)) {
        error[namespace] = translate("Field cannot be less than 1 and more than 3", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      }else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "hamlet":
      // if (!data) {
      //   error[namespace] = translate("COMMON:REQUIRE", {
      //     field: translate("CUSTOMER:ADDITIONAL_NAME"),
      //   });
      // } else 
      if (data &&(data.length > 3 || data.length <3)) {
        error[namespace] = translate("Field cannot be less than 1 and more than 3", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      }else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "postal_code":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
      case "province_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "longitude":
      if (data.length >=1 && !REGEX_CONSTANT.LNG_LAT.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data.length > 30) {
        error[namespace] = translate("Field cannot be less than 1 and more than 30", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "latitude":
      if (data.length >=1 && !REGEX_CONSTANT.JUST_LAT.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data.length > 30) {
        error[namespace] = translate("Field cannot be less than 1 and more than 30", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "emergency_contact_name":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data.length > 100 || data.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "emergency_contact_phone":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.PHONE_NUMBER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else if (data.length > 12 || data.length < 10) {
        error[namespace] = translate("Field cannot be less than 10 and more than 12", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "emergency_contact_address":
      if (data.length > 100 || data.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    // case "emergency_contact_address":
    //   if (data.length > 100 || data.length <= 1) {
    //     error[namespace] = translate("COMMON:MAX_LENGTH", {
    //       field: translate("CUSTOMER:ADDITIONAL_NAME"),
    //     });
    //   } else {
    //     error[namespace] = null;
    //   }
    //   break;
    // case "emergency_contact_address":
    //   if (data.length > 100 || data.length <= 1) {
    //     error[namespace] = translate("COMMON:MAX_LENGTH", {
    //       field: translate("CUSTOMER:ADDITIONAL_NAME"),
    //     });
    //   } else {
    //     error[namespace] = null;
    //   }
    //   break;
    case "salary":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data.length > 20) {
        error[namespace] = translate(
          "Field Salary Characters cannot be less than 1 and more than 20",
          {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          }
        );
      } else {
        error[namespace] = null;
      }
      break;

    case "driver_license_number":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data.length > 30 || data.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 30", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "driver_license_validity":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data.length > 30 || data.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 30", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;

      case "emergency_contact_relationship":
      if (data.length > 100) {
        error[namespace] = translate("Max character is 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;

      case "shift_start_hour":
        if (data.length > 2 || data>23) {
          error[namespace] = translate("Invalid format", {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          });
        }else if (!REGEX_CONSTANT.INTEGER.test(data)) {
          error[namespace] = translate("Invalid format", {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          });
        } else {
          error[namespace] = null;
        }
        break;

        case "shift_end_hour":
        if (data.length > 2 || data>23) {
          error[namespace] = translate("Invalid format", {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          });
        }else if (!REGEX_CONSTANT.INTEGER.test(data)) {
          error[namespace] = translate("Invalid format", {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          });
        } else {
          error[namespace] = null;
        }
        break;

        case "shift_start_min":
        if (data.length > 2 || data>59) {
          error[namespace] = translate("Invalid format", {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          });
        }else if (!REGEX_CONSTANT.INTEGER.test(data)) {
          error[namespace] = translate("Invalid format", {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          });
        } else {
          error[namespace] = null;
        }
        break;
        case "shift_end_min":
          if (data.length > 2 || data>59) {
            error[namespace] = translate("Invalid format", {
              field: translate("CUSTOMER:ADDITIONAL_NAME"),
            });
          }else if (!REGEX_CONSTANT.INTEGER.test(data)) {
            error[namespace] = translate("Invalid format", {
              field: translate("CUSTOMER:ADDITIONAL_NAME"),
            });
          } else {
            error[namespace] = null;
          }
          break;
          case "total_min":
          if (data<0) {
            error[namespace] = translate("Shift start cannot bigger than shift end", {
              field: translate("CUSTOMER:ADDITIONAL_NAME"),
            });
          }else {
            error[namespace] = null;
          }
          break;

    default:
      break;
  }
  return error;
};
